<template>
  <div v-if="hasPermission('p-super-admin')">
    <b-container fluid="lg">
        <b-card class="shadow-sm" no-body>
            <b-card-header header-bg-variant="transparent">
                <h4>Gerenciar e-24h</h4>
            </b-card-header>
            <b-card-body>
                <menuGerencial></menuGerencial>
            </b-card-body>
        </b-card>
        <router-view v-if="showContent"></router-view>
        <b-card class="shadow-sm my-3" no-body v-else>
            <b-card-body><h1>ERROR AQUI</h1></b-card-body>
        </b-card>
    </b-container>
  </div>
</template>

<script>
import menuGerencial from './menuGerencial.vue';
export default {
    name: 'habilitar-usuario-e-24h',
    components: { menuGerencial },
    data() {
        return {
            showContent: true,
        }
    },
    created() {
        const knownRoutes = ['habilitaUsuarioE24h'];
        this.showContent = knownRoutes.includes(this.$route.name);
    },
    watch: {
        '$route'(to) {
            const knownRoutes = [
                'habilitaUsuarioE24h',
            ]
            this.showContent = knownRoutes.includes(to.name)
        },
    },
    computed: {
        permissions() {
            return this.$store.state.auth.userpermissions.permissions;
        },
        error503() {
            return (window.location.href = '/nao-autorizado')
        }
    },
    methods: {
        hasPermission(permissao) {
            return this.permissions.includes(permissao)
        },
        navigateTo(routeName) {
            if (this.$route.path !== routeName) {
                this.$router.push({ name: routeName });
            } else {
                console.error('Estamos com problemas aqui!')
            }
        },
    }
};
</script>

<style scoped></style>